import React from "react";
import PropTypes from "prop-types";
import { getDate } from "utils/formatDate";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import ReactDropdown from "react-dropdown";

import { ChoVayCombo } from "constants/choVayConst";
import Pagination from "react-js-pagination";
import choVayConst from "constants/choVayConst";
import { LaiSuatText } from "constants/choVayConst";
import { catChuoi } from "utils/stringExtension";
import {
  startAndEndOfWeek,
  formatDayMonth,
  startAndEndOfMonth,
  startAndEndOfYear,
  GetDateHomQua,
} from "utils/formatDate";
import SearchChoVay from "components/CommonComponent/SearchChoVay";
import GiaHanKy from "components/CommonComponent/GiaHanKy";
import { Dropdown } from "react-bootstrap";
import TraBotGoc from "components/CommonComponent/TraBotGoc";
import VayThem from "components/CommonComponent/VayThem";
import { API_AUTH } from "service/common";
import configs from "constants/configs";
import InChoVay from "containers/Common/QuanLyChoVay/inChoVay";
import { pushNotification } from "utils/notifications";
import DongLaiContainer from "containers/Common/QuanLyChoVay/dongLai";
import ButtonChuyenForm from "components/CommonComponent/ButtonChuyenForm";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import { XuatExcelCamDo } from "../CommonComponent/XuatExcel/CamDo";
import InThuChiContainer from "containers/Common/ThuChi/InThuChiContainer";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import DoiTinhTrangNoContainer from "containers/Common/QuanLyChoVay/DoiTinhTrangNoContainer";
import XoaHopDongContainer from "containers/Common/QuanLyChoVay/XoaHopDongContainer";
import InMaVachTaiSanContainer from "containers/Common/QuanLyChoVay/InMaVachTaiSanContainer";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import GuiEmailContainer from "containers/Common/QuanLyChoVay/GuiEmailContainer";
import TinNhanContainer from "containers/Common/QuanLyChoVay/TinNhanContainer";
import ThemMoiContainer from "containers/Common/QuanLyChoVay/ThemMoiContainer";
import { convertDate } from "utils/formatDate";
import { getTotalDays } from "utils/choVayUtils";
import { getLaiSuat } from "constants/choVayConst";
import ThemMoiLoaiTaiSanContainer from "containers/Common/TaiSan/ThemMoiLoaiTaiSanContainer";
import Layout from "containers/Layout";
import TatToanContainer from "containers/Common/QuanLyChoVay/TatToanContainer";
import ChiTietTaiSanContainer from "containers/Common/TaiSan/ChiTietTaiSanContainer";
import GoiPhanMemApi from "../../service/goiPhanMemApi";
import { Cookies } from "react-cookie";
import ChiTietSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietSoTienDaTraContainer";
import ChiTietTongSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietTongSoTienDaTraContainer";
import { ModalInDanhSachDongLai } from "components/CommonComponent/DongLai/InDanhSachDongLai/ModalInDanhSachDongLai";
import CamDoApi from "service/camDoApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import userApi from "service/userApi";
import { convertToNumber } from "utils/numberExtension";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "../../service/cauHinhApi";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";
import ThayDoiLaiSuat from "components/CommonComponent/ThayDoiLaiSuat";
import ThayDoiKyLai from "components/CommonComponent/ThayDoiKyLai";
import LayoutV2 from "containers/LayoutV2";
import { ModelThietLapHienThi } from "./ModelThietLapHienThi";
import ThietLapHienThiApi from "../../service/QuanTriHeThong/ThietLapHienThiApi";
import { formatCurrency } from "utils/currencyFormat";

class CamDo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      showThemMoi: false,
      showDongLai: false,
      showTKNangCao: false,
      showGiaHanKy: false,
      showTraBotGoc: false,
      showVayThem: false,
      showThayDoiLaiSuat: false,
      showTatToan: false,
      showChiTietKhachHang: false,
      showSaoChep: false,
      choVay: {},
      dataSearch: {
        dateFrom: "01/01/2001",
        dateTo: "01/01/4000",
        code: "",
        customerName: "",
        address: "",
        noteTaiSan: "",
        status: "5",
        debt: "-1",
        userName: "",
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
        dongtungay: "01/01/2001",
        dongdenngay: "01/01/4000",
        manhanvien: "",
      },
      showInChoVay: false,
      thuChiId: 0,
      showChiTietHopDong: false,
      showDoiTinhTrangNo: false,
      showChiTietSoTienDaTra: false,
      showChiTietTongSoTienDaTra: false,
      choVayEdit: {},
      taiSanId: 0,
      showModalTaiSan: false,
      showMaVachTaiSan: 0,
      showXuatExcel3: false,
      isShowInDanhSachDongLai: false,
      dataInDanhSachDongLai: {},
      isLoadingTongTien: false,
      TotalMoney: 0,
      TotalPaid: 0,
      TotalPaidToDateNow: 0,
      TotalQuantity: 0,
      TT_Amercement: 0,
      TT_OtheFeeHangKy: 0,
      TT_OtherFee: 0,
      TT_PhiHoaHongTraGop: 0,
      TT_PhiKho: 0,
      TT_PhiPhatDongLai: 0,
      TT_ValueGoc: 0,
      TT_ValueLai: 0,
      TT_PhiPhatTatToan: 0,
      isQRThanhToan: false,
      isShowModalQRThanhToanHD: false,
      itemDataQR: {},
      isCauHinhKhachHangBinhAn: false,
      isCauHinhKhachHangVSNY: false,
      showThayDoiKyLai: false,
      isShowModalThietLapHienThi: false,
      objThietLapHienThiDanhSach: {},

      listTinhTrangNo: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
      listNhanVien: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
      isCauHinhT86: false,
    };
  }

  getNhanVienLabel = (value) => {
    const { listNhanVien } = this.state;
    if (!Array.isArray(listNhanVien) || value === "") return value;
    const found = listNhanVien.find((nv) => nv.value === value);
    return found ? found.label : value;
  };

  componentDidMount() {
    document.title = "Cầm đồ | Phần mềm quản lý cầm đồ Morman";
    let {
      getComboUser,
      getSoTaiSanThanhLyCamDo,
      getConfig,
      getPhanQuyenCamDo,
      showMaVachTaiSan,
    } = this.props;
    getPhanQuyenCamDo();
    getConfig();
    getComboUser();
    getSoTaiSanThanhLyCamDo();
    this.getThietLapHienThi();
    GoiPhanMemApi.GoiPhanMemCamDo().then((response) => {
      showMaVachTaiSan = response.data.MaVachTaiSan;
      this.setState({ showMaVachTaiSan });
    });

    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        const dataComboTinhTrangNew = [
          { value: "-1", label: "Tất cả" },
          ...dataComboTinhTrang,
        ];
        this.setState(
          { listTinhTrangNo: dataComboTinhTrangNew },
          this.getConfigKey,
        );
      }
    });
  }
  componentDidUpdate() {
    let { phanquyen, inthuchi } = this.props;
    let { showTatToan, dataSearch } = this.state;
    let { PhanQuyenCamDo, getPhanQuyenSuccess } = phanquyen;
    let { inThuChiShow } = inthuchi;
    let { camdo_danhsachcamdo } = PhanQuyenCamDo;
    if (
      getPhanQuyenSuccess &&
      (typeof camdo_danhsachcamdo === "undefined" ||
        camdo_danhsachcamdo === false)
    ) {
      window.location.href = configs.errorLink;
    }
    if (showTatToan && inThuChiShow) {
      dataSearch.status = "2";
      this.setState({ showTatToan: false });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  }
  getThietLapHienThi() {
    ThietLapHienThiApi.thietLapDanhSachCamDo().then((response) => {
      this.setState({ objThietLapHienThiDanhSach: response.data });
    });
  }
  getConfigKey() {
    userApi.combo().then((response) => {
      if (response.status === 200) {
        const users = response.data.map((item) => ({
          value: item.value == "0" ? "" : item.value,
          label: item.label,
        }));
        this.setState({ listNhanVien: users });
      }
    });

    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isCauHinhT86 = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsCauHinhT86.toUpperCase(),
          );
          if (isCauHinhT86 != null) {
            if (isCauHinhT86.valueConfig === "1") {
              console.log("isCauHinhT86", isCauHinhT86);
              this.setState({ isCauHinhT86: true });
            }
          }
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase(),
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }
          let { dataSearch } = this.state;
          const configNangCapKhachHangBinhAn = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHBinhAn.toUpperCase(),
          );
          if (configNangCapKhachHangBinhAn != null) {
            if (configNangCapKhachHangBinhAn.valueConfig === "1") {
              dataSearch.debt = "999";
              this.setState({ isCauHinhKhachHangBinhAn: true });
              this.setState({ dataSearch });
            }
          }
          const configNangCapKhachHangVSNY = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHVSNY.toUpperCase(),
          );
          if (configNangCapKhachHangVSNY != null) {
            if (configNangCapKhachHangVSNY.valueConfig === "1") {
              this.setState({ isCauHinhKhachHangVSNY: true });
            }
          }
          this.loadCamDo(dataSearch);
          this.loadTotalCamDo(dataSearch);
        }
      }
    });
  }
  onSearch = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadCamDo(dataSearch);
    this.loadTotalCamDo(dataSearch);
  };
  loadCamDo(dataSearch) {
    let { getListCamDo } = this.props;
    getListCamDo(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  loadTotalCamDo(dataSearch) {
    this.setState({ isLoadingTongTien: true });
    CamDoApi.toTalCamDo(
      dataSearch.dateFrom,
      dataSearch.dateTo,
      dataSearch.code,
      dataSearch.customerName,
      dataSearch.address,
      dataSearch.noteTaiSan,
      dataSearch.status,
      dataSearch.debt,
      dataSearch.userName,
      dataSearch.dongtungay,
      dataSearch.dongdenngay,
      dataSearch.manhanvien,
      dataSearch.pageIndex,
      dataSearch.pageSize,
    ).then((response) => {
      if (response.status === 200) {
        this.setState({ isLoadingTongTien: false });
        this.setState({
          TotalMoney: response.data.TotalMoney,
          TotalPaid: response.data.TotalPaid,
          TotalPaidToDateNow: response.data.TotalPaidToDateNow,
          ToTalGocConLai: response.data.ToTalGocConLai,
          TotalQuantity: response.data.TotalQuantity,
          TT_Amercement: response.data.TT_Amercement,
          TT_OtheFeeHangKy: response.data.TT_OtheFeeHangKy,
          TT_OtherFee: response.data.TT_OtherFee,
          TT_PhiHoaHongTraGop: response.data.TT_PhiHoaHongTraGop,
          TT_PhiKho: response.data.TT_PhiKho,
          TT_PhiPhatDongLai: response.data.TT_PhiPhatDongLai,
          TT_ValueGoc: response.data.TT_ValueGoc,
          TT_ValueLai: response.data.TT_ValueLai,
          TT_PhiPhatTatToan: response.data.TT_PhiPhatTatToan,
        });
      } else {
        this.setState({ isLoadingTongTien: false });
      }
      console.log(response, "check tổng");
    });
  }

  getListData = () => () => {
    let { dataSearch } = this.state;
    //dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadCamDo(dataSearch);
    this.loadTotalCamDo(dataSearch);
  };
  onChangeData = (field, event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState({ dataSearch });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setModalCamDoShow = (chovay) => () => {
    let choVayEdit = { ...chovay };
    if (chovay) {
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayTra = convertDate(chovay.NgayTra);
      if (chovay.NgayTraGoc != null) {
        choVayEdit.NgayTraGoc = convertDate(chovay.NgayTraGoc);
        choVayEdit.TongNgayVay = getTotalDays(
          choVayEdit.NgayVay,
          choVayEdit.NgayTraGoc,
        );
      } else {
        choVayEdit.TongNgayVay = getTotalDays(
          choVayEdit.NgayVay,
          choVayEdit.NgayTra,
        );
      }

      choVayEdit.EditCode = true;
      choVayEdit.LaiSuat = getLaiSuat(chovay, chovay.KieuLaiSuat);

      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;

      choVayEdit.NgayThanhToan = convertDate(chovay.DatePaid);
    }
    this.setState({
      choVayEdit,
    });
    let { showFormCamDo, themmoicamdo } = this.props;
    this.props.themmoicamdo.postCamDoReturn = false;
    let { isShowFormCamDo } = themmoicamdo;
    if (isShowFormCamDo) {
      let { dataSearch } = this.state;
      if ((choVayEdit.ChoVayId = undefined || choVayEdit.ChoVayId == 0)) {
        dataSearch.pageIndex = 1;
      }
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
    showFormCamDo(choVayEdit);
  };
  setIsCamDoReturn = () => {
    this.props.themmoicamdo.postCamDoReturn = false;
  };
  setModalGiaHanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showGiaHanKy } = this.state;
    if (data)
      this.setState({
        showGiaHanKy: !showGiaHanKy,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showGiaHanKy: !showGiaHanKy });
    if (showGiaHanKy) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setModalTatToanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTatToan } = this.state;
    if (data)
      this.setState({
        showTatToan: !showTatToan,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showTatToan: !showTatToan });
    if (showTatToan) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setModalTraBotGocShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTraBotGoc } = this.state;
    if (data)
      this.setState({
        showTraBotGoc: !showTraBotGoc,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showTraBotGoc: !showTraBotGoc });
    if (showTraBotGoc) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setModalVayThemShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showVayThem } = this.state;
    if (data)
      this.setState({
        showVayThem: !showVayThem,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showTatToan: false,
        showThayDoiLaiSuat: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showVayThem: !showVayThem });
    if (showVayThem) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setModalThayDoiLaiSuatShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiLaiSuat } = this.state;
    if (data)
      this.setState({
        showThayDoiLaiSuat: !showThayDoiLaiSuat,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showThayDoiLaiSuat: !showThayDoiLaiSuat });
    if (showThayDoiLaiSuat) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
    }
  };
  setModalThayDoiKyLaiShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiKyLai } = this.state;
    if (data)
      this.setState({
        showThayDoiKyLai: !showThayDoiKyLai,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showTatToan: false,
        showThayDoiLaiSuat: false,
      });
    else this.setState({ showThayDoiKyLai: !showThayDoiKyLai });
    if (showThayDoiKyLai) {
      let { dataSearch } = this.state;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
    }
  };

  setDongLaiModalShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    if (data)
      this.setState({
        showDongLai: !this.state.showDongLai,
        choVay: data,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showVayThem: false,
        showThayDoiLaiSuat: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showDongLai: !this.state.showDongLai });
    if (this.state.showDongLai) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setTKNangCaoModalShow = (dataSearch) => {
    this.setState({ showTKNangCao: !this.state.showTKNangCao });
    if (dataSearch && dataSearch && this.state.showTKNangCao) {
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  setInChoVayModalShow = () => () => {
    let { showInChoVay, choVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInChoVayModalShowTM = (choVay) => () => {
    let { showInChoVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ choVay });
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInThuChiModalShow = (thuChiId) => () => {
    let { showInPhieuThuChi } = this.props;
    showInPhieuThuChi(thuChiId);
  };

  setInDanhSachDongLaiShow = (data) => () => {
    this.setState({
      isShowInDanhSachDongLai: !this.state.isShowInDanhSachDongLai,
      dataInDanhSachDongLai: data,
    });
  };

  setModalChiTietKhachHangShow = (choVay) => () => {
    let { showChiTietKhachHang } = this.state;
    if (choVay)
      this.setState({ showChiTietKhachHang: !showChiTietKhachHang, choVay });
    else this.setState({ showChiTietKhachHang: !showChiTietKhachHang });
  };
  setModalChiTietHopDongShow = (choVay) => () => {
    let { showChiTietHopDong } = this.state;
    if (choVay)
      this.setState({ choVay, showChiTietHopDong: !showChiTietHopDong });
  };
  setModalDoiTinhTrangNoShow = (choVay) => () => {
    let { showDoiTinhTrangNo } = this.state;
    if (choVay)
      this.setState({ choVay, showDoiTinhTrangNo: !showDoiTinhTrangNo });
    if (this.state.showDoiTinhTrangNo) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
  };
  selectRow = (item) => () => {
    this.setState({ choVay: item });
  };
  setModalSaoChepShow = (chovay) => () => {
    let choVayEdit = { ...chovay, IsCopy: true };
    if (chovay) {
      choVayEdit.LaiSuat = getLaiSuat(chovay, chovay.KieuLaiSuat);
      choVayEdit.NgayVay = new Date();
      if (chovay.NgayTraGoc != null) {
        choVayEdit.NgayTraGoc = convertDate(chovay.NgayTraGoc);
        choVayEdit.TongNgayVay = getTotalDays(
          choVayEdit.NgayVay,
          choVayEdit.NgayTraGoc,
        );
      } else {
        choVayEdit.NgayTra = convertDate(chovay.NgayTra);

        choVayEdit.TongNgayVay = getTotalDays(
          choVayEdit.NgayVay,
          choVayEdit.NgayTra,
        );
      }
    }
    this.setState({
      choVayEdit,
    });
    let { showFormCamDo, themmoicamdo } = this.props;
    let { isShowFormCamDo } = themmoicamdo;
    if (isShowFormCamDo) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadCamDo(dataSearch);
      this.loadTotalCamDo(dataSearch);
    }
    showFormCamDo(choVayEdit);
  };
  hideModalLoaiTaiSanTM = () => {
    let { showModalLoaiTaiSan } = this.props;
    showModalLoaiTaiSan(false);
  };
  setModalTaiSan = (taiSanId) => () => {
    let { showModalTaiSan } = this.state;
    this.setState({ taiSanId, showModalTaiSan: !showModalTaiSan });
  };

  setModalChiTietTienDaTraShow = (choVay) => () => {
    let { showChiTietSoTienDaTra } = this.state;
    if (choVay)
      this.setState({
        showChiTietSoTienDaTra: !showChiTietSoTienDaTra,
        choVay,
      });
    else this.setState({ showChiTietSoTienDaTra: !showChiTietSoTienDaTra });
  };

  setModalChiTietTongTienDaTraShow = () => () => {
    let { showChiTietTongSoTienDaTra } = this.state;
    this.setState({ showChiTietTongSoTienDaTra: !showChiTietTongSoTienDaTra });
  };

  renderTableRows() {
    let {
      camdo,
      showXoaHopDong,
      showInMaVachTaiSan,
      showModalGuiEmail,
      showModalGuiTinNhan,
      phanquyen,
    } = this.props;
    let {
      choVay,
      showMaVachTaiSan,
      isCauHinhT86,
      isQRThanhToan,
      isCauHinhKhachHangVSNY,
      objThietLapHienThiDanhSach,
    } = this.state;
    let isShow = false;
    if (matchMedia) {
      var mq = window.matchMedia("(max-width: 768px)");
      isShow = mq.matches;
    }
    let { PhanQuyenCamDo } = phanquyen;
    let {
      camdo_doitinhtranghopdong,
      camdo_donglaicamdo,
      camdo_giahancamdo,
      camdo_guiemail,
      camdo_nhantin,
      camdo_suacamdo,
      camdo_tattoancamdo,
      camdo_thongtinchitiethopdong,
      camdo_thongtinchitietkhachhang,
      camdo_trabotgoc,
      camdo_vaythem,
      camdo_xoacamdo,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungCongTacVienNhanVien,
      SuDungSoTienVayConLai,
      SuDungMaNhanVien,
      SuDungTatToanSom,
      camdo_thaydoilaisuat,
      camdo_thaydoikylai,
    } = PhanQuyenCamDo;
    return camdo.objList.List.map((item, index) => (
      <div
        className={
          "custom-table-row " + (item === choVay && !isShow ? "active" : "")
        }
        key={"item" + index}
        onClick={this.selectRow(item)}
      >
        {item.DebtLevel === 50 && (
          <span className="line-job-color job-color-picker-1"></span>
        )}
        {item.DebtLevel === 20 && (
          <span className="line-job-color job-color-picker-2"></span>
        )}
        {objThietLapHienThiDanhSach.IsAnSTT != true && (
          <div className="custom-table-cell username-cell flex-basis-4 flex-basis-6-sm disk-mobile">
            <span className="mobile-column-name color7-bold">STT</span>
            <div className="center-wrapper">
              <p className="text-center color7">{item.IndexId}</p>
            </div>
          </div>
        )}
        {isCauHinhKhachHangVSNY == false && (
          <>
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-cell flex-basis-9 flex-basis-15-6-sm">
                <span className="mobile-column-name color7-bold">
                  Mã hợp đồng
                </span>
                <div className="center-wrapper">
                  <span className="profile_name word-break">
                    {camdo_thongtinchitiethopdong ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietHopDongShow(item)}
                      >
                        {item.Code}
                      </a>
                    ) : (
                      item.Code
                    )}
                  </span>
                  <span className="font-lai">
                    <br />
                    {getDate(item.NgayVay)}
                    <br />
                    {getDate(item.NgayTra)}
                  </span>
                </div>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
              (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                <div className="custom-table-cell flex-basis-9 flex-basis-10-sm">
                  <span className="mobile-column-name color7-bold">
                    {SuDungCongTacVienNhanVien ? "Mã nhân viên" : "Nhân viên"}
                  </span>
                  <div className="center-wrapper color7">
                    <p
                      className="text-left text-truncate"
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                      title={this.getNhanVienLabel(item.MaNhanVien)}
                    >
                      {this.getNhanVienLabel(item.MaNhanVien)}
                    </p>
                  </div>
                </div>
              )}

            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div
                className={`custom-table-cell ${
                  SuDungCongTacVienNhanVien || SuDungMaNhanVien
                    ? "flex-basis-12 flex-basis-11-8-sm"
                    : "flex-basis-10 flex-basis-11-8-sm"
                }`}
              >
                {/* <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm"> */}
                <span className="mobile-column-name color7-bold">
                  Tên khách hàng
                </span>
                <div className="center-wrapper color7">
                  <p>
                    {camdo_thongtinchitietkhachhang ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietKhachHangShow(item)}
                      >
                        <span title={item.CustomerName}>
                          {item.CustomerName}
                        </span>
                      </a>
                    ) : (
                      <span title={item.CustomerName}>{item.CustomerName}</span>
                    )}

                    <br />
                    {item.phoneCus && (
                      <span title={item.phoneCus} className="font-lai color7">
                        {" "}
                        {catChuoi(item.phoneCus, 10)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            )}
          </>
        )}
        {isCauHinhKhachHangVSNY == true && (
          <>
            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div
                className={`custom-table-cell ${
                  SuDungCongTacVienNhanVien || SuDungMaNhanVien
                    ? "flex-basis-12 flex-basis-11-8-sm"
                    : "flex-basis-10 flex-basis-11-8-sm"
                }`}
              >
                {/* <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm"> */}
                <span className="mobile-column-name color7-bold">
                  Tên khách hàng
                </span>
                <div className="center-wrapper color7">
                  <p>
                    {camdo_thongtinchitietkhachhang ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietKhachHangShow(item)}
                      >
                        <span title={item.CustomerName}>
                          {" "}
                          {item.CustomerName}{" "}
                        </span>
                      </a>
                    ) : (
                      <span title={item.CustomerName}>
                        {" "}
                        {item.CustomerName}{" "}
                      </span>
                    )}

                    <br />
                    {item.phoneCus && (
                      <span title={item.phoneCus} className="font-lai color7">
                        {" "}
                        {catChuoi(item.phoneCus, 10)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-cell flex-basis-9 flex-basis-15-6-sm">
                <span className="mobile-column-name color7-bold">
                  Mã hợp đồng
                </span>
                <div className="center-wrapper">
                  <span className="profile_name  word-break">
                    {camdo_thongtinchitiethopdong ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietHopDongShow(item)}
                      >
                        {item.Code}
                      </a>
                    ) : (
                      item.Code
                    )}
                  </span>
                  <span className="font-lai">
                    <br />
                    {getDate(item.NgayVay)}
                    <br />
                    {getDate(item.NgayTra)}
                  </span>
                </div>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
              (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
                  <span className="mobile-column-name color7-bold">
                    {SuDungCongTacVienNhanVien ? "Mã nhân viên" : "Nhân viên"}
                  </span>
                  <div className="center-wrapper">
                    <p
                      className="text-left text-truncate"
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                      title={this.getNhanVienLabel(item.MaNhanVien)}
                    >
                      {this.getNhanVienLabel(item.MaNhanVien)}
                    </p>
                  </div>
                </div>
              )}
          </>
        )}
        {objThietLapHienThiDanhSach.IsAnTSTheChap != true && (
          <div className="custom-table-cell flex-basis-10 flex-basis-9-sm">
            <span className="mobile-column-name color7-bold">TS thế chấp</span>
            <div className="center-wrapper color7">
              <p className="text-left" title={item.TaiSan}>
                {catChuoi(item.TaiSan, 10)}
              </p>
            </div>
          </div>
        )}

        {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
          this.state.isCauHinhKhachHangBinhAn == false && (
            <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
              <span className="mobile-column-name color7-bold">
                Số tiền vay
              </span>
              <div className="center-wrapper">
                <p className="text-right">
                  <span className="fontnew-500 color-do-bold">
                    {formatNumber(item.SoTienVayConLai)}
                  </span>{" "}
                  <br />{" "}
                  {item.IsDuNoGiamDan == true && (
                    <span className="font-lai color7">
                      {"Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"}
                    </span>
                  )}
                  {(item.IsDuNoGiamDan == undefined ||
                    item.IsDuNoGiamDan == false) && (
                    <span className="font-lai color7">
                      (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                    </span>
                  )}
                </p>
              </div>
            </div>
          )}
        {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
          this.state.isCauHinhKhachHangBinhAn == true && (
            <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
              <span className="mobile-column-name color7-bold">
                Tiền đưa khách
              </span>
              <div className="center-wrapper">
                <p className="text-right">
                  <span className="fontnew-500 color-xanh-bold">
                    {formatNumber(item.SoTienVayConLai)}
                  </span>{" "}
                  <br />{" "}
                  {item.IsDuNoGiamDan == true && (
                    <span className="font-lai color7">
                      {"Chi phí vay: " + formatMoney(item.ChiPhiVay, 2) + "%"}
                    </span>
                  )}
                  {(item.IsDuNoGiamDan == undefined ||
                    item.IsDuNoGiamDan == false) && (
                    <span className="font-lai color7">
                      (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                    </span>
                  )}
                </p>
              </div>
            </div>
          )}
        {objThietLapHienThiDanhSach.IsAnSoTienDaTra != true && (
          <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Số tiền đã trả
            </span>
            <div className="center-wrapper color-xanh-bold">
              <p className="text-right">
                <a
                  id=""
                  href={() => false}
                  className="blue btn-link"
                  onClick={this.setModalChiTietTienDaTraShow(item)}
                >
                  {formatNumber(
                    item.TC_ValueGoc +
                      item.TC_ValueLai +
                      item.TC_PhiKho +
                      item.TC_OtheFeeHangKy +
                      item.TC_Amercement +
                      item.TC_OtherFee +
                      item.TC_PhiPhatDongLai +
                      item.TC_PhiHoaHongTraGop +
                      item.TC_PhiPhatTatToan,
                  )}
                  {/* {formatNumber(item.Paided)} */}
                </a>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnTienVayConLai != true && (
          <div className="custom-table-cell flex-basis-9-5 flex-basis-13-sm ">
            <span className="mobile-column-name color7-bold">
              Tiền vay còn lại
            </span>
            <div className="center-wrapper ">
              <p className="text-right">
                <span className="fontnew-500 color7-bold">
                  {formatNumber(item.GocConLai)}
                </span>{" "}
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnChiPhiVayToiHomNay != true && (
          <div className="custom-table-cell flex-basis-10 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              {" "}
              {isCauHinhT86 ? "Chi phí vay đến hôm nay" : "Lãi đến hôm nay"}
            </span>
            <div className="center-wrapper color7">
              <p className="text-right">
                {item.IsDuNoGiamDan === true && (
                  <>
                    <span className="color7-bold">
                      {formatNumber(item.PaidToDateNow)}
                    </span>
                    <br />
                    {"(" + item.SoNgayChuaDong + " kỳ)"}
                  </>
                )}
                {(item.IsDuNoGiamDan === false ||
                  item.IsDuNoGiamDan === undefined) && (
                  <>
                    <span className="color7-bold">
                      {formatNumber(item.PaidToDateNow)}
                    </span>
                    <br />

                    {(item.KieuLaiSuat === 4 ||
                      item.KieuLaiSuat === 5 ||
                      item.TypePaid === 3) &&
                    item.SoNgayChuaDong > 0
                      ? "(" + item.SoNgayChuaDong + " kỳ)"
                      : (item.KieuLaiSuat === 6 || item.KieuLaiSuat === 7) &&
                          item.SoNgayChuaDong > 0
                        ? "(" + item.SoNgayChuaDong + " tuần)"
                        : item.SoNgayChuaDong > 0
                          ? "(" + item.SoNgayChuaDong + " ngày)"
                          : ""}
                  </>
                )}
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
          <div className="custom-table-cell flex-basis-8 flex-basis-6-sm">
            <span className="mobile-column-name color7-bold">Trạng thái</span>
            <div className="center-wrapper">
              <p className="text-center">
                <span
                  className={
                    item.Status === 4
                      ? "canh-bao-red-v2"
                      : item.Status === 3
                        ? "canh-bao-no"
                        : item.Status === 2
                          ? "dong"
                          : "dang-vay"
                  }
                >
                  {item.IsDuNoGiamDan === true && (
                    <>
                      {isCauHinhT86
                        ? choVayConst.StatusText[item.Status]
                        : choVayConst.StatusHoText[item.Status]}
                    </>
                  )}
                  {(item.IsDuNoGiamDan === false ||
                    item.IsDuNoGiamDan === undefined) && (
                    <> {choVayConst.StatusText[item.Status]}</>
                  )}
                </span>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnChucNang != true && (
          <div className="custom-table-cell flex-basis-15 flex-basis-15-6-sm  reponsive-cell-v2">
            <div className="center-wrapper">
              {item.Status !== 2 && (
                <div className="iconTableMorman">
                  {camdo_suacamdo && (
                    <a
                      href={() => false}
                      onClick={this.setModalCamDoShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Sửa"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <img src="/app-assets/images/icon-edit-v2.png" />
                      </PopoversBootrap>
                    </a>
                  )}
                  {camdo_donglaicamdo && (
                    <a
                      onClick={this.setDongLaiModalShow(item)}
                      href={() => false}
                    >
                      <PopoversBootrap
                        contentText="Đóng lãi"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="dong-lai-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}

                  {camdo_tattoancamdo && (
                    <a
                      href={() => false}
                      onClick={this.setModalTatToanShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Tất toán"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="tat-toan-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}
                  {camdo_trabotgoc && item.IsDuNoGiamDan === false && (
                    <a
                      href={() => false}
                      onClick={this.setModalTraBotGocShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Trả bớt gốc"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <img src="/app-assets/images/icon-tra-bot-goc-v2.png" />
                      </PopoversBootrap>
                    </a>
                  )}
                  {camdo_vaythem && item.IsDuNoGiamDan === false && (
                    <a
                      href={() => false}
                      onClick={this.setModalVayThemShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Vay thêm"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <img src="/app-assets/images/icon-vay-them-v2.png" />
                      </PopoversBootrap>
                    </a>
                  )}

                  <Dropdown className="DropNew trangthai-new dropdown-toggle">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img
                        src="/app-assets/images/icon-more.png"
                        alt="Dropdown icon"
                        className="dropdown-icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="dropdown-menu-v2 arrow"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="block-iconmm  vertical-layout">
                        {camdo_giahancamdo && item.IsDuNoGiamDan === false && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalGiaHanShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Gia hạn kỳ"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-gia-han.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Gia hạn</span>
                          </a>
                        )}
                        {camdo_thaydoilaisuat &&
                          item.IsDuNoGiamDan === false && (
                            <a
                              className="dropdown-item"
                              href={() => false}
                              onClick={this.setModalThayDoiLaiSuatShow(item)}
                            >
                              <PopoversBootrap
                                contentText="Đổi lãi suất"
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <img
                                  src="/app-assets/images/icon-thay-doi-lai-suat-v3.png"
                                  style={{
                                    transform: "scale(1.3)",
                                    marginRight: "6px",
                                    marginLeft: "5px",
                                  }}
                                />
                              </PopoversBootrap>
                              <span class="vertical-align-v2">
                                Đổi lãi suất
                              </span>
                            </a>
                          )}
                        {camdo_thaydoikylai && item.IsDuNoGiamDan === false && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalThayDoiKyLaiShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi kỳ lãi"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                src="/app-assets/images/icon-thay-doi-lai-suat-v3.png"
                                style={{
                                  transform: "scale(1.3)",
                                  marginRight: "6px",
                                  marginLeft: "5px",
                                }}
                              />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Đổi kỳ lãi</span>
                          </a>
                        )}
                        {camdo_nhantin && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiTinNhan}
                          >
                            <PopoversBootrap
                              contentText="Nhắn tin"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-tin-nhan.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Nhắn tin</span>
                          </a>
                        )}

                        {camdo_guiemail && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiEmail}
                          >
                            <PopoversBootrap
                              contentText="Gửi Email"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-gui-mail.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Gửi Email</span>
                          </a>
                        )}

                        {camdo_doitinhtranghopdong && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalDoiTinhTrangNoShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi tình trạng nợ"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-doi-tinh-trang-no.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">
                              Đổi tình trạng nợ
                            </span>
                          </a>
                        )}
                        {showMaVachTaiSan == 1 && (
                          <>
                            <a
                              href={() => false}
                              className="dropdown-item"
                              onClick={showInMaVachTaiSan}
                            >
                              <PopoversBootrap
                                contentText="In mã vạch"
                                titleText=""
                                trigger={["hover", "focus"]}
                                placement={"top"}
                              >
                                <img src="/app-assets/images/icon-in-ma-vach.png" />
                              </PopoversBootrap>
                              <span class="vertical-align-v2">In mã vạch</span>
                            </a>
                          </>
                        )}
                        {isQRThanhToan && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalQRThanhToanShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              contentText="QR thanh toán"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-qrcode-v2.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">QR code</span>
                          </a>
                        )}
                        {camdo_xoacamdo && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showXoaHopDong}
                          >
                            <PopoversBootrap
                              contentText="Xoá"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                style={{ marginLeft: "5px" }}
                                src="/app-assets/images/icon-xoa-v2.png"
                              />
                            </PopoversBootrap>
                            <span
                              class="vertical-align-v2"
                              style={{ color: "#FF5170", marginLeft: "10px" }}
                            >
                              Xóa
                            </span>
                          </a>
                        )}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
              {item.Status === 2 && (
                <div className="iconTableMorman">
                  <a
                    onClick={this.setModalSaoChepShow(item)}
                    href={() => false}
                  >
                    <PopoversBootrap
                      contentText="Sao chép"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <i className="mdi mdi-content-copy"></i>
                    </PopoversBootrap>
                  </a>
                  {showMaVachTaiSan == 1 && (
                    <a onClick={showInMaVachTaiSan} href={() => false}>
                      <PopoversBootrap
                        contentText="In mã vạch"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <i className="mdi mdi-barcode"></i>
                      </PopoversBootrap>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    ));
  }

  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadCamDo(dataSearch);
    this.loadTotalCamDo(dataSearch);
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  _onSelectDate = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    dataSearch.dateFrom = "01/01/2001";
    dataSearch.dateTo = "01/01/4001";
    if (value.value === "1") {
      dataSearch.dateFrom = formatDayMonth(new Date());
      dataSearch.dateTo = formatDayMonth(new Date());
    }
    if (value.value === "2") {
      var date2s = startAndEndOfWeek(new Date());
      dataSearch.dateFrom = formatDayMonth(date2s[0]);
      dataSearch.dateTo = formatDayMonth(date2s[1]);
    }
    if (value.value === "3") {
      var date1s = startAndEndOfMonth(new Date());
      dataSearch.dateFrom = formatDayMonth(date1s[0]);
      dataSearch.dateTo = formatDayMonth(date1s[1]);
    }
    if (value.value === "4") {
      var date4s = startAndEndOfYear(new Date());
      dataSearch.dateFrom = formatDayMonth(date4s[0]);
      dataSearch.dateTo = formatDayMonth(date4s[1]);
    }
    // Hôm qua
    if (value.value === "5") {
      dataSearch.dateFrom = GetDateHomQua();
      dataSearch.dateTo = GetDateHomQua();
    }
    this.setState({ dataSearch });
  };
  onChangeText = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.target.value;
    this.setState({ dataSearch });
  };
  xuatExcel = () => () => {
    let { dataSearch } = this.state;
    let {
      dateFrom,
      dateTo,
      code,
      customerName,
      address,
      noteTaiSan,
      status,
      debt,
      userName,
      dongtungay,
      dongdenngay,
    } = dataSearch;

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link =
      link +
      `quanlychovay/cam-do-xuat-excel?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}
      &noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DanhSachCamDo.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };
  xuatExcel2 = () => () => {
    let { dataSearch } = this.state;
    let {
      dateFrom,
      dateTo,
      code,
      customerName,
      address,
      noteTaiSan,
      status,
      debt,
      userName,
      dongtungay,
      dongdenngay,
      manhanvien,
    } = dataSearch;

    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link =
      link +
      `quanlychovay/cam-do-xuat-excel2?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}
      &noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DanhSachCamDo.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };

  xuatExcel3 = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = true;
    this.setState({ showXuatExcel3 });
  };

  hideXuatExcel = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = false;
    this.setState({ showXuatExcel3 });
  };
  toggleModalQRThanhToanHD() {
    this.setState({
      isShowModalQRThanhToanHD: !this.state.isShowModalQRThanhToanHD,
    });
  }
  setModalQRThanhToanShow = (hopdong) => () => {
    this.setState({ itemDataQR: hopdong });
    this.toggleModalQRThanhToanHD();
  };

  toggleModalThietLapHienThi() {
    this.setState({
      isShowModalThietLapHienThi: !this.state.isShowModalThietLapHienThi,
    });
  }
  setModalThietLapHienThi = () => () => {
    this.toggleModalThietLapHienThi();
  };

  render() {
    let {
      dataSearch,
      showDongLai,
      choVay,
      showTKNangCao,
      showGiaHanKy,
      showTraBotGoc,
      showVayThem,
      showThayDoiLaiSuat,
      showThayDoiKyLai,
      showTatToan,
      showInChoVay,
      showChiTietKhachHang,
      showChiTietHopDong,
      showDoiTinhTrangNo,
      showChiTietSoTienDaTra,
      showChiTietTongSoTienDaTra,
      taiSanId,
      showModalTaiSan,
      showXuatExcel3,
      choVayEdit,
      isCauHinhKhachHangVSNY,
      objThietLapHienThiDanhSach,
    } = this.state;
    let {
      camdo,
      getLanDongLaiChoVay,
      quanlychovay,
      quanlythuchi,
      user,
      getLichSuGiaHanChoVay,
      postGiaHanChoVay,
      postTraBotGocChoVay,
      getLichSuTraBotGocChoVay,
      postVayThemChoVay,
      postThayDoiLaiSuatChoVay,
      getLichSuVayThemChoVay,
      deleteTraBotGocChoVay,
      deleteVayThemChoVay,
      themmoicamdo,
      loaitaisan,
      inthuchi,
      phanquyen,
      cauhinh,
    } = this.props;
    let {
      TotalMoney,
      TotalPaid,
      TotalPaidToDateNow,
      TotalQuantity,
      TT_Amercement,
      TT_OtheFeeHangKy,
      TT_OtherFee,
      TT_PhiHoaHongTraGop,
      TT_PhiKho,
      TT_PhiPhatDongLai,
      TT_ValueGoc,
      TT_ValueLai,
      TT_PhiPhatTatToan,
    } = camdo.objList;

    let { getListCamDoLoading, SoTaiSanThanhLy } = camdo;
    let { isShowFormCamDo } = themmoicamdo;
    let { isShowModalLoaiTaiSan } = loaitaisan;
    let { inThuChiShow } = inthuchi;
    let { PhanQuyenCamDo } = phanquyen;
    let {
      camdo_inhopdongcamdo,
      camdo_themmoicamdo,
      camdo_xuatexceldanhsachcamdo,
      chonngaygiaodich,
      camdo_thaydoitienlai,
      thuchihopdong_xoaphieuthuchi,
      camdo_donglaicamdo,
      camdo_tattoancamdo,
      camdo_giahancamdo,
      camdo_trabotgoc,
      camdo_vaythem,
      camdo_thaydoilaisuat,
      camdo_suatientattoan,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungCongTacVienNhanVien,
      SuDungTachNoXau,
      SuDungMaNhanVien,
      SuDungSoTienVayConLai,
      SuDungTatToanSom,
      camdo_thaydoikylai,
    } = PhanQuyenCamDo;
    let { PhiKho } = cauhinh.objConfig;
    let { isCauHinhT86 } = this.state;
    const soTienDaTra =
      this.state.TT_Amercement +
      this.state.TT_OtheFeeHangKy +
      this.state.TT_OtherFee +
      this.state.TT_PhiHoaHongTraGop +
      this.state.TT_PhiKho +
      this.state.TT_PhiPhatDongLai +
      this.state.TT_ValueGoc +
      this.state.TT_ValueLai +
      this.state.TT_PhiPhatTatToan;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Cầm đồ</h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              {camdo_inhopdongcamdo && (
                                <a
                                  href={() => false}
                                  className="con-bgnew color-print1"
                                  onClick={this.setInChoVayModalShow()}
                                >
                                  <PopoversBootrap
                                    contentText="In hợp đồng"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/logo-print-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                            <li>
                              {camdo_xuatexceldanhsachcamdo && (
                                <a
                                  href={() => false}
                                  className="con-bgnew color-print1"
                                  onClick={this.xuatExcel()}
                                >
                                  <PopoversBootrap
                                    contentText=" Xuất excel 1"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/icon-tai-xuong-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                            <li>
                              {camdo_xuatexceldanhsachcamdo && (
                                <a
                                  href={() => false}
                                  className="con-bgnew color-print1"
                                  onClick={this.xuatExcel2()}
                                >
                                  <PopoversBootrap
                                    contentText=" Xuất excel 2"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/icon-tai-xuong-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                            <li>
                              {camdo_xuatexceldanhsachcamdo && (
                                <a
                                  href={() => false}
                                  className="con-bgnew color-print1"
                                  onClick={this.xuatExcel3()}
                                >
                                  <PopoversBootrap
                                    contentText=" Xuất excel 3"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img src="/app-assets/images/logo-xoa-v2.png" />
                                  </PopoversBootrap>
                                </a>
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="hide-table-main show-mobile-main hidden-des-main">
                        {camdo_themmoicamdo && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-border-new"
                              onClick={this.setModalCamDoShow()}
                              style={{ margin: "0px" }}
                            >
                              <i className="mdi mdi-plus"></i> Thêm mới
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card border-light mb-3 mt-1 hidden-mobile-main show-table-main card-v2"
                  style={{ marginTop: "-8px" }}
                >
                  <div className="card-body card-body-v2">
                    <div className="search-new">
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tìm kiếm
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Tên, sđt khách hàng"
                          onChange={this.onChangeData.bind(
                            this,
                            "customerName",
                          )}
                          onKeyDown={this.handleKeyDown}
                          value={dataSearch.customerName}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Trạng Thái
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("status")}
                          options={ChoVayCombo.StatusCombo}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          arrowClassName=""
                          value={dataSearch.status}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tình trạng
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("debt")}
                          // options={ChoVayCombo.TinhTrangCombo}
                          options={
                            SuDungTachNoXau
                              ? this.state.listTinhTrangNo.filter(
                                  (item) =>
                                    item.value !== 50 && item.value !== "50",
                                )
                              : this.state.listTinhTrangNo
                          }
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          value={dataSearch.debt}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Thời gian
                        </label>
                        <ReactDropdown
                          onChange={this._onSelectDate("ThoiGian")}
                          options={ChoVayCombo.ThoiGianCombo}
                          value={ChoVayCombo.ThoiGianDefault}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                        />
                      </div>
                      {SuDungCongTacVienNhanVien && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Mã nhân viên
                          </label>
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder="Mã nhân viên"
                            onChange={this.onChangeData.bind(
                              this,
                              "manhanvien",
                            )}
                            onKeyDown={this.handleKeyDown}
                            value={dataSearch.manhanvien}
                          />
                        </div>
                      )}
                      {SuDungMaNhanVien && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Chọn nhân viên
                          </label>
                          <ReactDropdown
                            onChange={this._onSelect("manhanvien")}
                            // options={ChoVayCombo.TinhTrangCombo}
                            options={this.state.listNhanVien}
                            placeholder="Tất cả"
                            controlClassName="form-control input-sm"
                            value={dataSearch.manhanvien}
                          />
                        </div>
                      )}
                      <div className="input-sm-new input-new-10 search-main-new">
                        <button
                          type="submit"
                          className="btn btn-info-new btn-seach-ds"
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i>
                          <span> &nbsp; Tìm kiếm</span>
                        </button>
                      </div>
                      <div className="input-sm-new input-new-5 search-main-new">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          &nbsp;
                        </label>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setTKNangCaoModalShow}
                        >
                          <i>
                            <PopoversBootrap
                              contentText="Tìm kiếm nâng cao"
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                className="icon-bred-home"
                                src="/app-assets/images/icon-fitter-v2.png"
                                alt=""
                                style={{ scale: "0.9", verticalAlign: "sub" }}
                              />
                              {/* <i className="mdi mdi-download"></i> */}
                            </PopoversBootrap>
                          </i>
                        </a>
                      </div>
                      <div className="input-sm-new input-new-3 search-main-new">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          &nbsp;
                        </label>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setModalThietLapHienThi()}
                        >
                          <i
                            className="fa fa-cog icon-bred-home"
                            style={{
                              scale: "0.9",
                              verticalAlign: "sub",
                              height: 30,
                            }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div
                      data-repeater-item
                      className="form row bg-search-form form-mobile-search"
                    >
                      <div
                        className="text-right  search-p mb-1 "
                        style={{ width: "100%" }}
                      >
                        <div className="form-search-mobile-new row">
                          <div
                            className="left-search-mobile-new"
                            style={{ width: "85%" }}
                          >
                            <div className="search-mobile-new">
                              <fieldset className="form-group position-relative mb-0">
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  placeholder="Tên, mã, sđt khách hàng ..."
                                  onChange={this.onChangeData.bind(
                                    this,
                                    "customerName",
                                  )}
                                  onKeyDown={this.handleKeyDown}
                                  value={dataSearch.customerName}
                                />
                                <div
                                  className="form-control-position"
                                  onClick={this.onSearch}
                                >
                                  <i className="mdi mdi-magnify"></i>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div className="right-search-mobile-new">
                            <div class="icon-search-mobile">
                              <a
                                href={() => false}
                                className="card-link blue darken-2"
                                onClick={this.setTKNangCaoModalShow}
                              >
                                <i>
                                  <PopoversBootrap
                                    contentText="Tìm kiếm nâng cao"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img
                                      className="icon-bred-home"
                                      src="/app-assets/images/icon-fitter-v2.png"
                                      alt=""
                                      style={{
                                        scale: "0.9",
                                        verticalAlign: "sub",
                                        marginTop: "-2px",
                                      }}
                                    />
                                    {/* <i className="mdi mdi-download"></i> */}
                                  </PopoversBootrap>
                                </i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card border-light mb-1 card-v2"
                  style={{
                    marginTop: "-35px",
                  }}
                >
                  <div className="card-body card-body-v2">
                    <div className="row col-sm-12 col-md-12 themoi-taisanthanhly hidden-mobile-main">
                      <div className="col-sm-12 col-md-10">
                        {camdo_themmoicamdo && (
                          <button
                            type="button"
                            className="btn btn-border-new"
                            onClick={this.setModalCamDoShow()}
                          >
                            <span>
                              <img
                                src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                                style={{ paddingBottom: "5px" }}
                              />{" "}
                              Thêm mới
                            </span>
                          </button>
                        )}
                        {/* <button
                          type="button"
                          className="btn btn-border-new"
                          onClick={this.setModalThietLapHienThi()}
                        >
                          <span>
                            <i className="fa fa-cog"></i> Thiết lập hiển thị
                          </span>
                        </button> */}
                      </div>
                      <div
                        className="col-sm-12 col-md-2 taisanthanhly"
                        style={{ padding: "0px" }}
                      >
                        <a
                          href={`${configs.mormanServer}trang-chu/quan-ly-tai-san/danh-sach-tai-san.aspx?Type=7`}
                        >
                          <div
                            style={{ marginTop: "7px", textAlign: "center" }}
                          >
                            <span className="number-breacrumb">
                              {SoTaiSanThanhLy}
                            </span>
                            {"  "}
                            <span
                              className="btn-link"
                              style={{ color: "#FF5170", fontSize: "1.2rem" }}
                            >
                              &nbsp;&nbsp;Tài sản cần thanh lý
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-3 d-flex just-end"></div>

                    <div className="Left808x200 Table-main-new css-table-ds">
                      <div className="loading-page1">
                        <div
                          className={
                            "loader loader-default " +
                            (getListCamDoLoading ? "is-active" : "")
                          }
                        ></div>
                      </div>
                      <div className="table-mobile sticky-table-bh2 table-mobile-hover">
                        <div
                          className="custom-table-wrapper"
                          style={
                            SuDungMaNhanVien || SuDungCongTacVienNhanVien
                              ? { overflowX: "auto", minHeight: "360px" }
                              : { minHeight: "360px" }
                          }
                        >
                          <div className="table-headers">
                            {objThietLapHienThiDanhSach.IsAnSTT != true && (
                              <div className="custom-table-header flex-basis-4 flex-basis-6-sm">
                                <p className="color-do-bold">
                                  STT
                                  <br />[{this.state.TotalQuantity}]
                                </p>
                              </div>
                            )}
                            {isCauHinhKhachHangVSNY == false && (
                              <>
                                {objThietLapHienThiDanhSach.IsAnMaHD !=
                                  true && (
                                  <div className="custom-table-header flex-basis-9 flex-basis-15-6-sm ">
                                    <p>Mã hợp đồng</p>
                                  </div>
                                )}
                                {objThietLapHienThiDanhSach.IsAnNhanVien !=
                                  true &&
                                  (SuDungCongTacVienNhanVien ||
                                    SuDungMaNhanVien) && (
                                    <div className="custom-table-header flex-basis-9 flex-basis-10-sm">
                                      <p>
                                        {SuDungCongTacVienNhanVien
                                          ? "Mã nhân viên"
                                          : "Nhân viên"}
                                      </p>
                                    </div>
                                  )}
                                {objThietLapHienThiDanhSach.IsAnTenKH !=
                                  true && (
                                  <div
                                    className={`custom-table-header ${
                                      SuDungCongTacVienNhanVien ||
                                      SuDungMaNhanVien
                                        ? "flex-basis-12 flex-basis-11-8-sm"
                                        : "flex-basis-10 flex-basis-11-8-sm"
                                    }`}
                                  >
                                    {/* <div className="custom-table-header flex-basis-12 flex-basis-11-8-sm"> */}
                                    <p>Tên khách hàng</p>
                                  </div>
                                )}
                              </>
                            )}
                            {isCauHinhKhachHangVSNY == true && (
                              <>
                                {objThietLapHienThiDanhSach.IsAnTenKH !=
                                  true && (
                                  <div
                                    className={`custom-table-header ${
                                      SuDungCongTacVienNhanVien ||
                                      SuDungMaNhanVien
                                        ? "flex-basis-12 flex-basis-11-8-sm"
                                        : "flex-basis-10 flex-basis-11-8-sm"
                                    }`}
                                  >
                                    {/* <div className="custom-table-header flex-basis-12 flex-basis-11-8-sm"> */}
                                    <p>Tên khách hàng</p>
                                  </div>
                                )}
                                {objThietLapHienThiDanhSach.IsAnMaHD !=
                                  true && (
                                  <div className="custom-table-header flex-basis-9 flex-basis-15-6-sm">
                                    <p>Mã hợp đồng</p>
                                  </div>
                                )}
                                {objThietLapHienThiDanhSach.IsAnNhanVien !=
                                  true &&
                                  (SuDungCongTacVienNhanVien ||
                                    SuDungMaNhanVien) && (
                                    <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                                      <p>
                                        {SuDungCongTacVienNhanVien
                                          ? "Mã nhân viên"
                                          : "Nhân viên"}
                                      </p>
                                    </div>
                                  )}
                              </>
                            )}
                            {objThietLapHienThiDanhSach.IsAnTSTheChap !=
                              true && (
                              <div className="custom-table-header flex-basis-10 flex-basis-9-sm">
                                <p className="text-center">TS thế chấp</p>
                              </div>
                            )}

                            {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
                              this.state.isCauHinhKhachHangBinhAn == false && (
                                <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                                  <p className="text-right">
                                    Số tiền vay
                                    <br />
                                    {this.state.isLoadingTongTien === true ? (
                                      <div className="dot-loading-tq">
                                        <div class="dots-5"></div>
                                      </div>
                                    ) : (
                                      <>
                                        <PopoversBootrap
                                          contentText={formatNumber(
                                            this.state.TotalMoney,
                                          )}
                                          trigger={["hover", "focus"]}
                                          placement={"bottom"}
                                        >
                                          <span
                                            className="color-do-bold"
                                            title={formatNumber(
                                              this.state.TotalMoney,
                                            )}
                                          >
                                            {formatCurrency(
                                              this.state.TotalMoney,
                                            )}
                                          </span>
                                        </PopoversBootrap>
                                      </>
                                    )}
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
                              this.state.isCauHinhKhachHangBinhAn == true && (
                                <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm">
                                  <p className="text-right">
                                    Tiền đưa khách
                                    <br />
                                    {this.state.isLoadingTongTien === true ? (
                                      <div className="dot-loading-tq">
                                        <div class="dots-5"></div>
                                      </div>
                                    ) : (
                                      <>
                                        <span
                                          className="color-red-bold"
                                          title={formatNumber(
                                            this.state.TotalMoney,
                                          )}
                                        >
                                          {formatCurrency(
                                            this.state.TotalMoney,
                                          )}
                                        </span>
                                      </>
                                    )}
                                  </p>
                                </div>
                              )}
                            {objThietLapHienThiDanhSach.IsAnSoTienDaTra !=
                              true && (
                              <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm fix-cell-header">
                                <p className="text-right">
                                  Số tiền đã trả
                                  <br />
                                  {this.state.isLoadingTongTien === true ? (
                                    <div className="dot-loading-tq">
                                      <div class="dots-5"></div>
                                    </div>
                                  ) : (
                                    <>
                                      <PopoversBootrap
                                        contentText={formatNumber(soTienDaTra)}
                                        trigger={["hover", "focus"]}
                                        placement={"bottom"}
                                      >
                                        <span
                                          className="color-xanh-bold"
                                          title={formatNumber(soTienDaTra)}
                                        >
                                          {formatCurrency(soTienDaTra)}
                                        </span>
                                      </PopoversBootrap>
                                    </>
                                  )}
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnTienVayConLai !=
                              true && (
                              <div className="custom-table-header flex-basis-9-5 flex-basis-13-sm fix-cell-header">
                                <p className="text-right">
                                  Tiền vay còn lại
                                  <br />
                                  {this.state.isLoadingTongTien === true ? (
                                    <div className="dot-loading-tq">
                                      <div class="dots-5"></div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="color7-bold">
                                        {(() => {
                                          if (
                                            Math.round(
                                              this.state.ToTalGocConLai,
                                              0,
                                            ) >= 1000000000
                                          ) {
                                            return `${formatNumber(
                                              (
                                                Math.round(
                                                  this.state.ToTalGocConLai,
                                                  0,
                                                ) / 1000
                                              ).toFixed(0),
                                            )}K`;
                                          }
                                          return formatNumber(
                                            Math.round(
                                              this.state.ToTalGocConLai,
                                              0,
                                            ),
                                          );
                                        })()}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnChiPhiVayToiHomNay !=
                              true && (
                              <div className="custom-table-header flex-basis-10 flex-basis-13-sm ">
                                <p className="text-right">
                                  {isCauHinhT86
                                    ? "Chi phí vay đến hôm nay"
                                    : "Lãi đến hôm nay"}
                                  <br />
                                  {this.state.isLoadingTongTien === true ? (
                                    <div className="dot-loading-tq">
                                      <div class="dots-5"></div>
                                    </div>
                                  ) : (
                                    <>
                                      <span className="color-cam-bold">
                                        {(() => {
                                          if (
                                            Math.round(
                                              this.state.TotalPaidToDateNow,
                                              0,
                                            ) >= 1000000000
                                          ) {
                                            return `${formatNumber(
                                              (
                                                Math.round(
                                                  this.state.TotalPaidToDateNow,
                                                  0,
                                                ) / 1000
                                              ).toFixed(0),
                                            )}K`;
                                          }
                                          return formatNumber(
                                            Math.round(
                                              this.state.TotalPaidToDateNow,
                                              0,
                                            ),
                                          );
                                        })()}
                                      </span>
                                    </>
                                  )}
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnTrangThai !=
                              true && (
                              <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                                <p className="tab-header text-center">
                                  Trạng thái
                                </p>
                              </div>
                            )}
                            {objThietLapHienThiDanhSach.IsAnChucNang !=
                              true && (
                              <div className="custom-table-header flex-basis-15 flex-basis-15-6-sm">
                                <p className="tab-header">Chức năng</p>
                              </div>
                            )}
                          </div>
                          <div className="custom-table-body">
                            {this.renderTableRows()}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          "paniation-new paniation-new1 d-flex justify-content-center " +
                          (this.state.TotalQuantity === 0 ? "hidden" : "")
                        }
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-3 card-v2 card-footer-v2">
                  <div className="card-body card-body-v2">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <span className="color7">
                          {this.state.TotalQuantity === 0 ? (
                            "Hiển thị 0 - 0 / Tổng số 0"
                          ) : (
                            <>
                              Hiển thị{" "}
                              {(dataSearch.pageIndex - 1) *
                                dataSearch.pageSize +
                                1}{" "}
                              -{" "}
                              {Math.min(
                                dataSearch.pageIndex * dataSearch.pageSize,
                                this.state.TotalQuantity,
                              )}{" "}
                              / Tổng số {this.state.TotalQuantity}
                            </>
                          )}
                        </span>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div
                          className={
                            "paniation-new paniation-new1 d-flex justify-content-center " +
                            (TotalQuantity === 0 ? "hidden" : "")
                          }
                          style={{ float: "right" }}
                        >
                          <nav aria-label="Page navigation">
                            <Pagination
                              activePage={dataSearch.pageIndex}
                              itemsCountPerPage={dataSearch.pageSize}
                              totalItemsCount={this.state.TotalQuantity}
                              pageRangeDisplayed={5}
                              onChange={this.handlePageChange}
                              itemClass="page-item border-none"
                              linkClass="page-link border-none"
                              activeClass="active"
                            />
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isShowFormCamDo && (
          <ThemMoiContainer
            show={
              isShowFormCamDo &&
              !isShowModalLoaiTaiSan &&
              !showInChoVay &&
              !inThuChiShow
            }
            onHide={this.setModalCamDoShow(null)}
            data={choVayEdit}
            inPhieuThu={this.setInThuChiModalShow}
            inHopDong={this.setInChoVayModalShowTM}
            setIsCamDoReturn={this.setIsCamDoReturn}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            SuDungMaNhanVien={SuDungMaNhanVien}
            SuDungTatToanSom={SuDungTatToanSom}
          ></ThemMoiContainer>
        )}
        {showChiTietKhachHang && (
          <CustomerDetail
            show={showChiTietKhachHang && !showChiTietHopDong}
            onHide={this.setModalChiTietKhachHangShow(choVay)}
            showChiTietHopDong={this.setModalChiTietHopDongShow}
            data={choVay}
          ></CustomerDetail>
        )}
        {showXuatExcel3 && (
          <XuatExcelCamDo
            dataSearch={dataSearch}
            show={showXuatExcel3}
            onHide={this.hideXuatExcel()}
          ></XuatExcelCamDo>
        )}
        {showDongLai && (
          <DongLaiContainer
            show={
              showDongLai &&
              !inThuChiShow &&
              !this.state.isShowInDanhSachDongLai
            }
            onHide={this.setDongLaiModalShow(choVay)}
            onShowPhieuThu={this.setInThuChiModalShow}
            onShowInDanhSachDongLai={this.setInDanhSachDongLaiShow}
            data={choVay}
            thaydoitienlai={camdo_thaydoitienlai}
            chonngaygiaodich={chonngaygiaodich}
            xoaphieuthuchi={thuchihopdong_xoaphieuthuchi}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            isShowPhiKho={PhiKho}
            isCauHinhKhachHangVSNY={isCauHinhKhachHangVSNY}
            buttonLeft={
              <ButtonChuyenForm
                // showDongLai={this.setDongLaiModalShow(choVay)}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={camdo_tattoancamdo}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={camdo_giahancamdo}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={camdo_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={camdo_vaythem}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
                quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
              ></ButtonChuyenForm>
            }
          ></DongLaiContainer>
        )}
        {showGiaHanKy && (
          <GiaHanKy
            show={showGiaHanKy}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalGiaHanShow(choVay)}
            getLichSuGiaHanChoVay={getLichSuGiaHanChoVay}
            postGiaHanChoVay={postGiaHanChoVay}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={camdo_donglaicamdo}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={camdo_tattoancamdo}
                // showGiaHaKy={this.setModalGiaHanShow(choVay)}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={camdo_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={camdo_vaythem}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
                quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
              ></ButtonChuyenForm>
            }
          ></GiaHanKy>
        )}
        {showTraBotGoc && (
          <TraBotGoc
            show={showTraBotGoc && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postTraBotGocChoVay={postTraBotGocChoVay}
            getLichSuTraBotGocChoVay={getLichSuTraBotGocChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalTraBotGocShow(choVay)}
            deleteTraBotGoc={deleteTraBotGocChoVay}
            chonngaygiaodich={chonngaygiaodich}
            quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={camdo_donglaicamdo}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={camdo_tattoancamdo}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={camdo_giahancamdo}
                // showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={camdo_vaythem}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></TraBotGoc>
        )}
        {showVayThem && (
          <VayThem
            show={showVayThem && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postVayThemChoVay={postVayThemChoVay}
            getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalVayThemShow(choVay)}
            deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={camdo_donglaicamdo}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={camdo_tattoancamdo}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={camdo_giahancamdo}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={camdo_trabotgoc}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                // showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
                quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></VayThem>
        )}
        {showThayDoiLaiSuat && (
          <ThayDoiLaiSuat
            show={showThayDoiLaiSuat && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postThayDoiLaiSuatChoVay={postThayDoiLaiSuatChoVay}
            getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalThayDoiLaiSuatShow(choVay)}
            deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={camdo_donglaicamdo}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={camdo_tattoancamdo}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={camdo_giahancamdo}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={camdo_trabotgoc}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={camdo_vaythem}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></ThayDoiLaiSuat>
        )}
        {showThayDoiKyLai && (
          <ThayDoiKyLai
            show={showThayDoiKyLai && !inThuChiShow}
            data={choVay}
            getLanDongLaiChoVay={getLanDongLaiChoVay}
            postThayDoiLaiSuatChoVay={postThayDoiLaiSuatChoVay}
            getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            quanlychovay={quanlychovay}
            quanlythuchi={quanlythuchi}
            onHide={this.setModalThayDoiKyLaiShow(choVay)}
            deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={camdo_donglaicamdo}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={camdo_tattoancamdo}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={camdo_giahancamdo}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={camdo_trabotgoc}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
                showThayDoiKyLai={this.setModalThayDoiKyLaiShow(choVay)}
                quyenThayDoiKyLai={camdo_thaydoikylai}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={camdo_vaythem}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></ThayDoiKyLai>
        )}
        {showTatToan && (
          <TatToanContainer
            show={showTatToan && !inThuChiShow}
            data={choVay}
            onHide={this.setModalTatToanShow(choVay)}
            chonngaygiaodich={chonngaygiaodich}
            isShowPhiKho={PhiKho}
            quyenSuaTienTatToan={camdo_suatientattoan}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungTatToanSom={SuDungTatToanSom}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={camdo_donglaicamdo}
                //showTatToan={this.setModalTatToanShow(choVay)}
                showGiaHaKy={this.setModalGiaHanShow(choVay)}
                quyenGiaHan={camdo_giahancamdo}
                showTraBotGoc={this.setModalTraBotGocShow(choVay)}
                quyenTraBotGoc={camdo_trabotgoc}
                showVayThem={this.setModalVayThemShow(choVay)}
                quyenVayThem={camdo_vaythem}
                showThayDoiLaiSuat={this.setModalThayDoiLaiSuatShow(choVay)}
                quyenThayDoiLaiSuat={camdo_thaydoilaisuat}
                IsDuNoGiamDan={choVay.IsDuNoGiamDan}
              ></ButtonChuyenForm>
            }
          ></TatToanContainer>
        )}
        <SearchChoVay
          data={dataSearch}
          show={showTKNangCao}
          onHide={this.setTKNangCaoModalShow}
          userCombo={user.combo}
          type={3}
          trangs={"CamDo"}
          listTinhTrangNo={this.state.listTinhTrangNo}
        ></SearchChoVay>
        {showInChoVay && (
          <InChoVay
            data={choVay}
            show={showInChoVay}
            onHide={this.setInChoVayModalShow()}
          ></InChoVay>
        )}

        {inThuChiShow && (
          <InThuChiContainer
            show={inThuChiShow}
            onHide={this.setInThuChiModalShow()}
          ></InThuChiContainer>
        )}

        {this.state.isShowInDanhSachDongLai && (
          <ModalInDanhSachDongLai
            show={this.state.isShowInDanhSachDongLai}
            onHide={this.setInDanhSachDongLaiShow()}
            data={this.state.dataInDanhSachDongLai}
          />
        )}

        {showChiTietHopDong && (
          <ChiTietHopDongContainer
            show={showChiTietHopDong && !showModalTaiSan}
            onHide={this.setModalChiTietHopDongShow(choVay)}
            data={choVay}
            setModalTaiSan={this.setModalTaiSan}
          ></ChiTietHopDongContainer>
        )}
        {showDoiTinhTrangNo && (
          <DoiTinhTrangNoContainer
            show={showDoiTinhTrangNo}
            onHide={this.setModalDoiTinhTrangNoShow(choVay)}
            data={choVay}
          ></DoiTinhTrangNoContainer>
        )}
        {showChiTietSoTienDaTra && (
          <ChiTietSoTienDaTraContainer
            show={showChiTietSoTienDaTra}
            onHide={this.setModalChiTietTienDaTraShow(choVay)}
            data={choVay}
          ></ChiTietSoTienDaTraContainer>
        )}
        {showChiTietTongSoTienDaTra && (
          <ChiTietTongSoTienDaTraContainer
            show={showChiTietTongSoTienDaTra}
            onHide={this.setModalChiTietTongTienDaTraShow()}
            TT_Amercement={this.state.TT_Amercement}
            TT_OtheFeeHangKy={this.state.TT_OtheFeeHangKy}
            TT_OtherFee={this.state.TT_OtherFee}
            TT_PhiHoaHongTraGop={this.state.TT_PhiHoaHongTraGop}
            TT_PhiKho={this.state.TT_PhiKho}
            TT_PhiPhatDongLai={this.state.TT_PhiPhatDongLai}
            TT_ValueGoc={this.state.TT_ValueGoc}
            TT_ValueLai={this.state.TT_ValueLai}
            TT_PhiPhatTatToan={this.state.TT_PhiPhatTatToan}
          ></ChiTietTongSoTienDaTraContainer>
        )}

        <XoaHopDongContainer
          data={choVay}
          getList={this.getListData()}
        ></XoaHopDongContainer>

        <InMaVachTaiSanContainer data={choVay}></InMaVachTaiSanContainer>
        <GuiEmailContainer data={choVay}></GuiEmailContainer>
        <TinNhanContainer data={choVay}></TinNhanContainer>
        {isShowModalLoaiTaiSan && (
          <ThemMoiLoaiTaiSanContainer
            show={isShowModalLoaiTaiSan}
            onHide={this.hideModalLoaiTaiSanTM}
          ></ThemMoiLoaiTaiSanContainer>
        )}
        {showModalTaiSan && (
          <ChiTietTaiSanContainer
            show={showModalTaiSan}
            taiSanId={taiSanId}
            onHide={this.setModalTaiSan()}
          ></ChiTietTaiSanContainer>
        )}
        {this.state.isShowModalQRThanhToanHD && (
          <ModelQRThanhToanHD
            show={this.state.isShowModalQRThanhToanHD}
            onHide={this.toggleModalQRThanhToanHD.bind(this)}
            hopdong={this.state.itemDataQR}
          />
        )}
        {this.state.isShowModalThietLapHienThi && (
          <ModelThietLapHienThi
            show={this.state.isShowModalThietLapHienThi}
            onHide={this.toggleModalThietLapHienThi.bind(this)}
            data={this.state.objThietLapHienThiDanhSach}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            SuDungMaNhanVien={SuDungMaNhanVien}
            getThietLapHienThi={this.getThietLapHienThi.bind(this)}
          />
        )}
      </LayoutV2>
    );
  }
}

CamDo.propTypes = {
  getList: PropTypes.func,
};

export default CamDo;
